'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@achra/ui/lib/utils';
import { Popover, PopoverContent, PopoverTrigger } from '@achra/ui/popover';
import { CheckCircle2, CheckIcon, ChevronDown, Circle } from 'lucide-react';
import { useMemo, useState } from 'react';
import type { CumulativeType } from '@/modules/finances/lib/expenses-metric-chart-search-params';
import { CUMULATIVE_OPTIONS } from './cumulative-options';
interface ExpensesMetricCumulativeFilterProps {
  isCumulative: boolean;
  cumulativeType: CumulativeType;
  onToggleCumulative: () => void;
  onChangeCumulativeType: (value: CumulativeType) => void;
}
function ExpensesMetricCumulativeFilter(t0) {
  const $ = _c(44);
  const {
    isCumulative,
    cumulativeType,
    onToggleCumulative,
    onChangeCumulativeType
  } = t0;
  const [isOpen, setIsOpen] = useState(false);
  let t1;
  bb0: {
    if (!isCumulative) {
      t1 = "Cumulative";
      break bb0;
    }
    t1 = cumulativeType === "relative" ? "Relative Cumulative" : "Absolute Cumulative";
  }
  const buttonLabel = t1;
  const t2 = isCumulative ? isOpen : false;
  let t3;
  if ($[0] !== isCumulative) {
    t3 = open => {
      setIsOpen(isCumulative ? open : false);
    };
    $[0] = isCumulative;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== isOpen || $[3] !== onToggleCumulative) {
    t4 = () => {
      if (isOpen) {
        setIsOpen(false);
      }
      onToggleCumulative();
    };
    $[2] = isOpen;
    $[3] = onToggleCumulative;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = isCumulative && "border-primary bg-primary text-primary-foreground";
  let t6;
  if ($[5] !== t5) {
    t6 = cn("border-input dark:bg-input/30 flex size-4 shrink-0 items-center justify-center rounded-sm border shadow-xs", t5);
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== isCumulative) {
    t7 = isCumulative && <CheckIcon className="size-2.5" />;
    $[7] = isCumulative;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t6 || $[10] !== t7) {
    t8 = <span aria-hidden="true" className={t6}>{t7}</span>;
    $[9] = t6;
    $[10] = t7;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t4 || $[13] !== t8) {
    t9 = <button type="button" className="flex h-full items-center gap-2 px-3 text-sm font-semibold" onClick={t4}>{t8}</button>;
    $[12] = t4;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  const t10 = !isCumulative;
  const t11 = isCumulative ? "text-foreground hover:bg-accent/40 cursor-pointer" : "text-muted-foreground cursor-not-allowed";
  let t12;
  if ($[15] !== t11) {
    t12 = cn("flex h-full items-center gap-2 border-l px-3 text-sm font-semibold transition-colors", t11);
    $[15] = t11;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] !== buttonLabel) {
    t13 = <span className="hidden xl:inline">{buttonLabel}</span>;
    $[17] = buttonLabel;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  const t14 = isCumulative ? cumulativeType === "relative" ? "Relative" : "Absolute" : "Cumulative";
  let t15;
  if ($[19] !== t14) {
    t15 = <span className="xl:hidden">{t14}</span>;
    $[19] = t14;
    $[20] = t15;
  } else {
    t15 = $[20];
  }
  const t16 = isOpen && "rotate-180";
  let t17;
  if ($[21] !== t16) {
    t17 = cn("size-4 transition-transform", t16);
    $[21] = t16;
    $[22] = t17;
  } else {
    t17 = $[22];
  }
  let t18;
  if ($[23] !== t17) {
    t18 = <ChevronDown className={t17} />;
    $[23] = t17;
    $[24] = t18;
  } else {
    t18 = $[24];
  }
  let t19;
  if ($[25] !== t10 || $[26] !== t12 || $[27] !== t13 || $[28] !== t15 || $[29] !== t18) {
    t19 = <PopoverTrigger asChild={true}><button type="button" disabled={t10} className={t12}>{t13}{t15}{t18}</button></PopoverTrigger>;
    $[25] = t10;
    $[26] = t12;
    $[27] = t13;
    $[28] = t15;
    $[29] = t18;
    $[30] = t19;
  } else {
    t19 = $[30];
  }
  let t20;
  if ($[31] !== t19 || $[32] !== t9) {
    t20 = <div className="bg-background flex h-9 items-center overflow-hidden rounded-lg border">{t9}{t19}</div>;
    $[31] = t19;
    $[32] = t9;
    $[33] = t20;
  } else {
    t20 = $[33];
  }
  let t21;
  if ($[34] !== cumulativeType || $[35] !== onChangeCumulativeType) {
    t21 = CUMULATIVE_OPTIONS.map(option => {
      const isActive = cumulativeType === option.value;
      return <button key={option.value} type="button" className={cn("hover:bg-accent/40 flex items-start gap-3 rounded-md border p-3 text-left transition-colors", isActive && "bg-accent border-primary/20")} onClick={() => {
        onChangeCumulativeType(option.value);
        setIsOpen(false);
      }}><div className="text-primary mt-0.5">{isActive ? <CheckCircle2 className="size-4" /> : <Circle className="size-4" />}</div><div className="flex min-w-0 flex-1 flex-col gap-1"><span className="text-sm font-semibold">{option.label}</span><span className="text-muted-foreground text-xs leading-5">{option.description}</span></div></button>;
    });
    $[34] = cumulativeType;
    $[35] = onChangeCumulativeType;
    $[36] = t21;
  } else {
    t21 = $[36];
  }
  let t22;
  if ($[37] !== t21) {
    t22 = <PopoverContent align="end" className="w-88 max-w-[calc(100vw-2rem)] p-2"><div className="flex flex-col gap-2">{t21}</div></PopoverContent>;
    $[37] = t21;
    $[38] = t22;
  } else {
    t22 = $[38];
  }
  let t23;
  if ($[39] !== t2 || $[40] !== t20 || $[41] !== t22 || $[42] !== t3) {
    t23 = <Popover open={t2} onOpenChange={t3}>{t20}{t22}</Popover>;
    $[39] = t2;
    $[40] = t20;
    $[41] = t22;
    $[42] = t3;
    $[43] = t23;
  } else {
    t23 = $[43];
  }
  return t23;
}
export { ExpensesMetricCumulativeFilter };